export default "__VITE_ASSET__BB5Ewwwk__"